<div
  svcTestId="ap-form-approval__section--content"
  class="col-span-full min-h-[207px] pb-[clamp(1rem,4vh,3rem)]"
>
  @if (!canEdit()) {
    <div svcTestId="ap-form-approval__section--approver" class="mt-4">
      <p class="inline-flex input-label-size input-label-weight text-default">
        {{ 'Aprovador' | transloco }}
      </p>

      <div class="flex flex-wrap gap-2 mt-2">
        @if (selectedApproverIds().length) {
          @for (approverId of selectedApproverIds(); track approverId; let approverIndex = $index) {
            <div class="flex items-center gap-2">
              <svc-smart-user-avatar
                [ids]="approverId"
                [size]="24"
              ></svc-smart-user-avatar>
              <span class="text-default text-base font-medium">
                {{ selectedApproverLabels()[approverIndex] || '-' }}
              </span>
            </div>
          }
        } @else {
          <span class="text-base">-</span>
        }
      </div>
    </div>
  } @else {
    <svc-chip
      svcTestId="ap-form-approval__multiselect--approvers"
      class="h-fit mt-4 block"
      inputId="action-plan-register-form-approvers"
      type="multiple"
      [formControl]="approverControl()"
      [placeholder]="'Opcional' | transloco"
      [label]="'Aprovador' | transloco"
      [options]="usersOptions()"
      [loading]="isLoading()"
      [truncateTextValue]="true"
    >
      <ng-template let-option="option">
        <div class="flex items-center gap-2 min-w-0">
          <svc-smart-user-avatar
            [ids]="option?.value"
            [size]="20"
          ></svc-smart-user-avatar>
          <span class="truncate">{{ option?.label }}</span>
        </div>
      </ng-template>
    </svc-chip>
  }
</div>
